/**
 * Small "PREVIEW" pill shown next to a RAW filename to remind editors
 * that the image on screen is a lightweight JPEG proxy — the original
 * CR2/CR3/NEF must be downloaded from the "Download Original" button
 * for retouching.
 *
 *   <PreviewBadge filename="IMG_0005.CR3" />
 *   → renders the pill
 *
 *   <PreviewBadge filename="party.jpg" />
 *   → renders nothing (already a browser-native format)
 */
const RAW_EXT = new Set([
  "cr2", "cr3", "nef", "arw", "dng", "orf", "rw2", "raf", "sr2", "pef",
  "heic", "heif",
]);

function extOf(name) {
  if (!name) return "";
  const dot = name.lastIndexOf(".");
  return dot >= 0 ? name.slice(dot + 1).toLowerCase() : "";
}

export function isRawFilename(name) {
  return RAW_EXT.has(extOf(name));
}

export function PreviewBadge({ filename, className = "" }) {
  if (!isRawFilename(filename)) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-sm bg-amber-100 text-amber-900 border border-amber-300 px-1.5 py-0.5 text-[9px] font-mono font-semibold tracking-wider uppercase ${className}`}
      title="Preview only — download the original file to retouch and re-upload the edited version"
      data-testid={`preview-badge-${filename}`}
    >
      Preview
    </span>
  );
}

export default PreviewBadge;
